// Mock data and functions for frontend-only testing

export const mockFormSubmission = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Store in localStorage for demo purposes
  const existingSubmissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  const newSubmission = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString(),
    status: 'pending'
  };
  
  existingSubmissions.push(newSubmission);
  localStorage.setItem('contactSubmissions', JSON.stringify(existingSubmissions));
  
  console.log('Form submitted (mock):', newSubmission);
  
  // Simulate successful submission
  return {
    success: true,
    message: 'Your request has been submitted successfully',
    data: newSubmission
  };
};

// Function to retrieve mock submissions (for testing)
export const getMockSubmissions = () => {
  return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
};

// Clear mock submissions
export const clearMockSubmissions = () => {
  localStorage.removeItem('contactSubmissions');
};
